import { queryOptions } from "@tanstack/react-query";
import type {
  CreateStateInput,
  DocumentTypeId,
  PaginatedResponse,
  PaginationParams,
  StateDto,
  StateId,
  UpdateStateInput,
} from "@yalana/contracts";
import { fetchApi } from "../../../../shared/infrastructure/api-client";
import { toListSearchParams } from "../../../../shared/utils/list-search-params";

export const statesQueries = {
  all: () => ["fsm", "states"] as const,
  list: (
    params: PaginationParams & {
      documentTypeId?: DocumentTypeId;
      customerId?: string;
      q?: string;
      sort?: string;
      dir?: "asc" | "desc";
    } = { page: 1, pageSize: 25 },
  ) =>
    queryOptions({
      queryKey: [...statesQueries.all(), "list", params] as const,
      queryFn: () =>
        fetchApi<PaginatedResponse<StateDto>>("/api/fsm/states", {
          searchParams: toListSearchParams({
            page: params.page,
            pageSize: params.pageSize,
            documentTypeId: params.documentTypeId,
            customerId: params.customerId,
            q: params.q,
            sort: params.sort,
            dir: params.dir,
          }),
        }),
    }),
  detail: (id: StateId) =>
    queryOptions({
      queryKey: [...statesQueries.all(), id] as const,
      queryFn: () => fetchApi<StateDto>(`/api/fsm/states/${id}`),
      enabled: id !== ("new" as unknown as StateId),
    }),
};

export const statesMutations = {
  create: () => ({
    mutationFn: (data: CreateStateInput) =>
      fetchApi<StateDto>("/api/fsm/states", {
        method: "POST",
        body: JSON.stringify(data),
      }),
  }),
  update: (id: StateId) => ({
    mutationFn: (data: UpdateStateInput) =>
      fetchApi<StateDto>(`/api/fsm/states/${id}`, {
        method: "PATCH",
        body: JSON.stringify(data),
      }),
  }),
  delete: () => ({
    mutationFn: (id: StateId) =>
      fetchApi<void>(`/api/fsm/states/${id}`, { method: "DELETE" }),
  }),
};
